export default __webpack_public_path__ + "static/media/brave_zone_background_s2.52ff0ba9.jpg";